import { ROUTES } from "../constants";
import { apiRequest } from "./api.client";

export { ApiError as SoapApiError } from "./api.errors";

// ── Types ──────────────────────────────────────────────────────────────────────

export interface SoapNotePayload {
  chief_complaint?: string;
  hpi?: string;
  ros?: string;
  physical_exam?: string;
  lab_results?: string;
  primary_dx?: string;
  differential_dx?: string;
  clinical_impression?: string;
  medications_text?: string;
  procedures?: string;
  follow_up?: string;
  patient_education?: string;
  referrals?: string;
}

export interface SoapNoteResponse extends SoapNotePayload {
  soap_note_id: string;
  visit_id: string;
  created_at: string;
  updated_at: string;
  created_by: string;
}

export interface UserInfo {
  user_id: string;
  user_no?: number;
  clinic_id?: string;
  display_id?: string;
  first_name: string;
  last_name: string;
  role: string;
  specialization?: string;
  registration_number?: string;
}

// ── API ────────────────────────────────────────────────────────────────────────

export const SoapAPI = {
  upsertNote(visitId: string, payload: SoapNotePayload): Promise<SoapNoteResponse> {
    return apiRequest<SoapNoteResponse>(ROUTES.VISIT_SOAP_NOTE(visitId), {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  getNote(visitId: string): Promise<SoapNoteResponse> {
    return apiRequest<SoapNoteResponse>(ROUTES.VISIT_SOAP_NOTE(visitId));
  },

  getUser(userId: string): Promise<UserInfo> {
    return apiRequest<UserInfo>(ROUTES.USER_INFO(userId));
  },
};
